"use client";
import { jsx as d } from "react/jsx-runtime";
import f, { useState as p, useEffect as m, useCallback as s, use as x } from "react";
const n = f.createContext(null), C = ({
  router: e,
  segments: o,
  children: a
}) => {
  const [l, t] = p(!0);
  m(() => {
    o.length > 1 && t(!0);
  }, [o]);
  const c = s(() => {
    t(!1), setTimeout(() => {
      e.back();
    }, 500);
  }, [e]), u = s(
    (r, i) => {
      t(!1), setTimeout(() => {
        e.back();
      }, 500), setTimeout(() => e.push(r, i), 600);
    },
    [e]
  );
  return /* @__PURE__ */ d(
    n.Provider,
    {
      value: {
        isOpen: l,
        closeModal: c,
        closeModalWithRoute: u
      },
      children: a
    }
  );
}, v = () => {
  const e = x(n);
  if (!e)
    throw new Error(
      "useModalContext: `context` is undefined. Seems you forgot to wrap all popover components within `<RouterModal />`"
    );
  return e;
};
export {
  C as ModalProvider,
  v as useModalContext
};
